import { Box } from '@mantine/core'
import React from 'react'
import {
  FilterCollapsibleHierarchicalMenu,
  FilterCollapsibleList,
  FilterCollapsiblePriceRange,
  FilterCollapsibleRange,
  FilterCollapsibleToggle,
} from './FilterCollapsibleItem'
import { ALLOWED_FILTERS_FOR_CATEGORIES } from './helpers'

export const Filter = ({
  isTradeCapable,
  rootPath,
  showParentLevel,
  rootCategory,
}: {
  isTradeCapable: boolean
  rootPath?: string
  showParentLevel?: boolean
  rootCategory?: string
}) => (
  <Box>
    <FilterCollapsibleHierarchicalMenu
      attributes={['category.lvl0', 'category.lvl1', 'category.lvl2']}
      title="Category"
      rootPath={rootPath}
      showParentLevel={showParentLevel}
    />

    {isTradeCapable && (
      <FilterCollapsibleRange
        title="Trade discount"
        attribute="minTradeDiscount"
        suffix="%"
      />
    )}
    <FilterCollapsiblePriceRange title="Price" attribute="minPrice" />

    <FilterCollapsibleToggle
      title="Availability"
      attribute="isInStock"
      label="In stock"
      on="true"
    />

    <FilterCollapsibleList title="Item Location" attribute="locationTypes" />

    {/* <FilterCollapsibleToggle
      title="Vintage"
      attribute="itemType"
      label="Vintage"
      on="VINTAGE"
    /> */}
    <FilterCollapsibleList title="Item type" attribute="itemTypes" />
    {/* {ALLOWED_FILTERS_FOR_CATEGORIES.FABRIC.includes(rootCategory) && (
        <FilterCollapsibleList title="Fabric type" attribute="fabricTypes" />
      )} */}
    {ALLOWED_FILTERS_FOR_CATEGORIES.WIDTH.includes(rootCategory) && (
      <FilterCollapsibleRange
        title="Width"
        attribute="widths"
        suffix='"'
        showInputs
        inputSuffix="(inches)"
      />
    )}
    {ALLOWED_FILTERS_FOR_CATEGORIES.HEIGHT.includes(rootCategory) && (
      <FilterCollapsibleRange
        title="Height"
        attribute="heights"
        suffix='"'
        showInputs
        inputSuffix="(inches)"
      />
    )}
    {/* {ALLOWED_FILTERS_FOR_CATEGORIES.LENGTH.includes(rootCategory) && (
      <FilterCollapsibleRange title="Length" attribute="lengths" suffix='"' />
    )} */}
    {ALLOWED_FILTERS_FOR_CATEGORIES.DEPTH.includes(rootCategory) && (
      <FilterCollapsibleRange
        title="Depth"
        attribute="depths"
        suffix='"'
        showInputs
        inputSuffix="(inches)"
      />
    )}
    <FilterCollapsibleList
      title="Customization Available"
      attribute="customizations"
      operator="and"
    />
    <FilterCollapsibleRange
      title="Lead time"
      attribute="leadTimesInWeeks"
      suffix=" weeks"
    />
    <FilterCollapsibleList
      title="Brand"
      attribute="brand"
      sortBy={['name:asc']}
      excludedLabels={['NOBRAND-']}
    />
    {/* <FilterCollapsibleList title="Width" attribute="widths" suffix='"' /> */}
    {/* <FilterCollapsibleList title="Color" attribute="colors" />
    <FilterCollapsibleList title="Material" attribute="materials" />
    <FilterCollapsibleList title="Size" attribute="sizes" /> */}
    {/* <FilterCollapsibleList
      title="Weight"
      attribute="weights"
      suffix='"'
      isNumericResults
    />  */}
    {/* <FilterCollapsibleList title="Finish" attribute="finishes" /> */}
  </Box>
)
